import { BLOCK_TYPE } from "contracts/enums/metrics";
import type { ContentBlock } from "contracts/report/blocks";

export const BLOCK_TYPES: Array<{
  value: ContentBlock["type"];
  label: string;
}> = [
  { value: BLOCK_TYPE.NOTE, label: "Note" },
  { value: BLOCK_TYPE.EVIDENCE, label: "Evidence" },
  { value: BLOCK_TYPE.RECOMMENDATION, label: "Recommendation" },
  { value: BLOCK_TYPE.RUBRIC_ITEM, label: "Rubric item" },
  { value: BLOCK_TYPE.SCORE_COMPONENT, label: "Score component" },
  { value: BLOCK_TYPE.QA, label: "Q&A" },
];

export function defaultBlock(
  type: ContentBlock["type"] = BLOCK_TYPE.NOTE,
): ContentBlock {
  if (type === BLOCK_TYPE.NOTE) {
    return { type, title: "Note", body: "Describe the observation." };
  }
  if (type === BLOCK_TYPE.EVIDENCE) {
    return {
      type,
      title: "Evidence",
      body: "Paste the evidence or observation.",
      source: null,
    };
  }
  if (type === BLOCK_TYPE.RECOMMENDATION) {
    return {
      type,
      title: "Recommendation",
      body: "Describe the recommended change.",
    };
  }
  if (type === BLOCK_TYPE.RUBRIC_ITEM) {
    return { type, label: "Rubric item", score: 50, maxScore: 100, note: null };
  }
  if (type === BLOCK_TYPE.SCORE_COMPONENT) {
    return {
      type,
      label: "Score component",
      score: 50,
      weight: null,
      detail: null,
    };
  }
  return { type, q: "Question", a: "Answer" };
}
